<template>
  <div class="q-mt-md promo-container">
    <!-- Header Of the page -->
    <h3 class="text-bold q-m-md inline-block">
      {{ headerMessage }}
    </h3>

    <div class="row">
      <div class="col-8">
        <q-card
          v-if="getCrossPromotionsLoading"
          class="new-tab-loading-wrapper"
        >
          <div>
            <q-spinner color="primary" size="3em" />
          </div>
        </q-card>
        <q-card v-else class="timeline-card">
          <q-card-section>
            <q-tabs
              v-model="eventTab"
              dense
              class="text-grey"
              active-color="primary"
              indicator-color="primary"
              align="justify"
              inline-label
              @update:model-value="(val) => onTabChange(val)"
            >
              <q-tab name="newEventTab" label="New">
                <font-awesome-icon
                  icon="fa-add"
                  size="xl"
                  color="primary"
                  class="q-ml-sm"
                />
              </q-tab>
              <q-tab name="editEventTab" label="Edit " disable>
                <font-awesome-icon
                  icon="fa-edit"
                  size="xl"
                  color="primary"
                  class="q-ml-sm"
                />
              </q-tab>
            </q-tabs>
            <q-separator />
          </q-card-section>

          <q-card-section>
            <div class="row q-mt-lg items-start">
              <div class="col-6">
                <div>
                  <q-input
                    dense
                    outlined
                    class="q-mt-sm"
                    v-model="currentEvent.promoName"
                    label="Promo Name"
                    :rules="[
                      (val) =>
                        val.length >= 3 || 'Please use Minimum 3 characters',
                    ]"
                    lazy-rules
                    :readonly="currentEvent.stats === 'closed'"
                  />
                  <q-input
                    dense
                    class="q-mt-sm"
                    outlined
                    v-model="currentEvent.link"
                    label="Promo URL"
                    :rules="[
                      async (val) =>
                        (await httpCheck(val)) ||
                        'Please start with http:// or https://',
                    ]"
                    lazy-rules
                    :readonly="currentEvent.stats === 'closed'"
                  />

                  <GamesFilter
                    :value="currentEvent.gameIDs"
                    @update:value="(val) => (currentEvent.gameIDs = val)"
                    :disabled="currentEvent.stats === 'closed'"
                    :edit="updateGamesFilterKey"
                  />

                  <q-toggle
                    class="q-mt-sm"
                    :color="getEnv === 'stage' ? 'secondary' : 'primary'"
                    v-model="currentEvent.showImages"
                    label="Show Images"
                    :disable="currentEvent.stats === 'closed'"
                  />
                  <q-input
                    dense
                    class="q-mt-sm"
                    outlined
                    v-model="currentEvent.imageSrc"
                    label="Desktop Image Path"
                    :readonly="currentEvent.stats === 'closed'"
                    :disable="!currentEvent.showImages"
                  />
                  <q-input
                    dense
                    class="q-mt-sm"
                    outlined
                    v-model="currentEvent.mobileImageSrc"
                    label="Mobile Image Path"
                    :readonly="currentEvent.stats === 'closed'"
                    :disable="!currentEvent.showImages"
                  />
                  <div
                    class="icons-wrapper"
                    v-if="currentEvent.stats !== 'closed'"
                  >
                    <q-btn round dense flat @click="selectImageURL">
                      <div class="icon-content" @click="selectImageURL">
                        <font-awesome-icon icon="image" size="sm" />
                      </div>
                    </q-btn>
                  </div>
                  <q-input
                    dense
                    class="q-mt-sm"
                    type="textarea"
                    outlined
                    v-model="currentEvent.htmlText"
                    label="HTML Content"
                    :readonly="currentEvent.stats === 'closed'"
                  />

                  <div
                    :class="
                      currentEvent?.htmlText?.length > 80 ? 'text-red' : ''
                    "
                  >
                    {{ currentEvent?.htmlText?.length }} / 80
                  </div>
                </div>
              </div>

              <div class="col-6 flex justify-center">
                <q-date
                  :color="getEnv === 'stage' ? 'secondary' : 'primary'"
                  :text-color="getEnv === 'stage' ? 'black' : 'white'"
                  event-color="red"
                  v-model="selectedEventDatePicker"
                  range
                  mask="MM/DD/YYYY"
                  :options="getFreeEventDates(this.currentEvent, this.crossPromotionsList)"
                  @update:model-value="(val) => onChangeEventDate(val)"
                />
              </div>
            </div>
          </q-card-section>
        </q-card>
      </div>
      <div class="col-4 q-pl-md">
        <q-card class="timeline-card">
          <q-card-section class="timeline-card-section">
            <div class="flex no-wrap items-center justify-between">
              <q-input
                v-if="!getCrossPromotionsLoading"
                borderless
                v-model="searchText"
                input-class="text-left"
                class="q-ml-md"
                :label="
                  getEnv === 'prod' ? 'Production Promos' : 'Stage Promos'
                "
                @update:model-value="(val) => onSearchChange(val)"
              >
                <template v-slot:prepend>
                  <font-awesome-icon
                    v-if="searchText === ''"
                    icon="fa-search"
                    size="sm"
                    color="primary"
                  />
                  <font-awesome-icon
                    v-else
                    icon="fa-xmark"
                    size="xl"
                    color="primary"
                    name="clear"
                    class="cursor-pointer"
                    @click="() => onSearchChange('')"
                  />
                </template>
              </q-input>
              <q-btn round color="primary" v-if="!getCrossPromotionsLoading">
                <font-awesome-icon
                  icon="fa-calendar-days"
                  size="xl"
                  color="primary"
                />
                <q-popup-proxy
                  @before-show="updateProxyDateInTimeline"
                  transition-show="scale"
                  transition-hide="scale"
                >
                  <q-date
                    v-model="proxyDate"
                    mask="MM/DD/YYYY"
                    color="grey-2"
                    text-color="black"
                    :options="availableEventsDates"
                  >
                    <div class="row items-center justify-end q-gutter-sm">
                      <q-btn
                        label="Cancel"
                        color="primary"
                        flat
                        v-close-popup
                      />
                      <q-btn
                        label="OK"
                        color="primary"
                        flat
                        @click="setEventSearchDate"
                        v-close-popup
                      />
                    </div>
                  </q-date>
                </q-popup-proxy>
              </q-btn>
            </div>
          </q-card-section>

          <q-card-section v-if="getCrossPromotionsLoading">
            <div class="q-ma-md">
              <q-skeleton height="15px" />
              <q-skeleton height="40px" class="q-mt-md" />
            </div>
            <div class="q-ma-md">
              <q-skeleton height="15px" />
              <q-skeleton height="40px" class="q-mt-md" />
            </div>
            <div class="q-ma-md">
              <q-skeleton height="15px" />
              <q-skeleton height="40px" class="q-mt-md" />
            </div>
            <div class="q-ma-md">
              <q-skeleton height="15px" />
              <q-skeleton height="40px" class="q-mt-md" />
            </div>
          </q-card-section>

          <q-card-section v-else>
            <q-timeline>
              <q-timeline-entry
                v-for="event in crossPromotionsList"
                :key="event.eventKey"
                class="timeline-entry"
                @click="() => timelineEventChange(event)"
                side="left"
                :title="event.promoName"
                :subtitle="
                  displayDatesInTimeline(
                    event.eventDateStart,
                    event.eventDateEnd
                  )
                "
                :color="event.timeLineColor"
              >
                <template v-slot:title>
                  {{ event.promoName }}
                </template>
              </q-timeline-entry>
            </q-timeline>
          </q-card-section>
        </q-card>
      </div>
    </div>

    <div class="relative-class q-mt-lg" v-if="!getCrossPromotionsLoading">
      <div class="promo-banner-container q-mb-lg">
        <div class="row">
          <div class="col-6 align-promo">
            <div class="promo-title">Desktop View</div>
            <div class="desktop-promo promo-content-wrapper">
              <div class="row full-width">
                <div
                  class="fill"
                  :class="currentEvent.showImages ? 'col-4' : ''"
                >
                  <div v-show="currentEvent.showImages">
                    <img
                      v-if="currentEvent.imageSrc"
                      :src="currentEvent.imageSrc"
                      :alt="currentEvent.imageSrc"
                    />
                    <div v-else class="no-image-icon">
                      <font-awesome-icon
                        icon="fa-regular fa-image"
                        size="xl"
                        color="primary"
                      />
                      <div class="q-mt-md">˜117 x 100</div>
                    </div>
                  </div>
                </div>
                <div
                  class="promo-content"
                  :class="currentEvent.showImages ? 'col-8' : 'col-12'"
                  v-html="truncatedHtmlText"
                ></div>
              </div>
            </div>
          </div>

          <div class="col-6 align-promo">
            <div class="promo-title">Mobile View</div>
            <div class="mobile-promo promo-content-wrapper">
              <div class="row full-width">
                <div
                  class="fill"
                  :class="currentEvent.showImages ? 'col-4' : ''"
                >
                  <div v-show="currentEvent.showImages">
                    <img
                      v-if="currentEvent.mobileImageSrc"
                      :src="currentEvent.mobileImageSrc"
                      :alt="currentEvent.mobileImageSrc"
                    />
                    <div v-else class="no-image-icon">
                      <font-awesome-icon
                        icon="fa-regular fa-image"
                        size="xl"
                        color="primary"
                      />
                      <div class="q-mt-md">˜100 x 100</div>
                    </div>
                  </div>
                </div>
                <div
                  class="promo-content"
                  :class="currentEvent.showImages ? 'col-8' : 'col-12'"
                  v-html="truncatedHtmlText"
                ></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="q-mt-lg q-mb-md flex justify-between">
        <div>
          <q-btn
            v-if="eventTab === 'newEventTab'"
            label="Add Promo"
            @click="createEventModal = true"
            color="positive"
            :disable="handlerDisableCreateEvent()"
          />
          <q-btn
            v-else
            label="Edit Promo"
            @click="createEventModal = true"
            color="positive"
            :disable="handlerDisableCreateEvent()"
          />
          <q-btn
            v-if="getEnv === 'stage' && isProdEnv"
            class="q-ml-md"
            color="primary"
            label="switch to production"
            @click="sendToProd"
            :disable="currentEvent.promoName.length < 3"
          >
            <q-tooltip self="center left">
              Send fields to Production environment</q-tooltip
            >
            <font-awesome-icon
              class="q-ml-md"
              icon="fa-share"
              size="lg"
              :color="currentEvent.promoName.length < 3 ? 'gray' : 'white'"
            />
          </q-btn>
        </div>
        <div>
          <q-btn
            v-if="eventTab === 'editEventTab'"
            class="q-ml-sm"
            label="Duplicate Promo"
            @click="() => duplicatePromo(currentEvent)"
            color="primary"
          />
          <q-btn
            v-else
            class="q-ml-sm"
            label="reset promo"
            @click="() => newEvent()"
            color="primary"
          />
          <q-btn
            v-if="
              eventTab === 'editEventTab' &&
              this.currentEvent.stats !== 'closed' &&
              this.currentEvent.stats !== ''
            "
            class="q-ml-sm"
            color="negative"
            @click="deleteEventModal = true"
          >
            <font-awesome-icon icon="fa-trash" size="sm" color="negative"
          /></q-btn>
        </div>
      </div>
    </div>

    <q-dialog v-model="createEventModal">
      <q-card class="card-modal">
        <q-card-section>
          <h6 class="q-ml-sm">
            {{ !this.currentEvent.eventKey ? createModalText : editModalText }}
          </h6>
          <strong class="q-ml-sm"> ({{ currentEvent.promoName.toUpperCase() }}) </strong>
        </q-card-section>

        <q-card-actions class="flex justify-between q-ma-md">
          <q-btn flat label="Cancel" color="primary" v-close-popup />
          <q-btn label="Confirm" color="positive" @click="createEventConfirm" />
        </q-card-actions>
      </q-card>
    </q-dialog>
    <q-dialog v-model="deleteEventModal">
      <q-card class="card-modal">
        <q-card-section>
          <h6 class="q-ml-sm">{{ deleteModalText }}</h6>
          <strong class="q-ml-sm"> ({{ currentEvent.promoName.toUpperCase() }}) </strong>
        </q-card-section>

        <q-card-actions class="flex justify-between q-ma-md">
          <q-btn flat label="Cancel" color="primary" v-close-popup />
          <q-btn label="Delete" color="primary" @click="deleteEventConfirm" />
        </q-card-actions>
      </q-card>
    </q-dialog>
    <SelectImageModal :key="getIsOpenSelectImageModal" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import _ from "lodash";
import SelectImageModal from "../components/modals/SelectImageModal.vue";
import {
  convertDateIntoAmericanFormat,
  getEventByDate,
  datePickerTimelineOptionsFn,
  getFreeEventDates
} from "@/utils";
import GamesFilter from "../components/games-filter/GamesFilter.vue";

export default {
  name: "CrossPromotionView",

  data() {
    return {
      isProdEnv: false,
      eventTab: "newEventTab",
      headerMessage: "Cross Promotions",

      crossPromotionsList: [],
      gamesList: [],

      updateGamesFilterKey: false,

      currentEvent: {
        promoName: "",
        eventDateStart: "",
        eventDateEnd: "",
        stats: "",
        htmlText: "",
        imageSrc: "",
        showImages: true,
        mobileImageSrc: "",
        link: "",
        gameIDs: [],
      },

      initialDate: null,
      proxyDate: null,
      promoEventsFirstDate: "",
      promoEventsLastDate: "",
      selectedEventDatePicker: { from: "", to: "" },
      searchText: "",

      deleteEventModal: false,
      createEventModal: false,
      createModalText: "Are you sure you want to Create the Promo?",
      editModalText: "Are you sure you want to Edit the Promo?",
      deleteModalText: "Are you sure you want to DELETE the Promo?",

      convertDateIntoAmericanFormat,
      getEventByDate,
      datePickerTimelineOptionsFn,
      getFreeEventDates
    };
  },

  components: {
    SelectImageModal,
    GamesFilter,
  },

  async created() {
    this.isProdEnv = process.env.NODE_ENV === "production";
  },

  // Async mounted to wait for API requests
  async mounted() {
    await this.getAllPromos();
    await this.actionGetGamesFeed();

    // Check if the component came from StageToProd and fill with previous stage infos
    if (this.getPromoToProd.promoName && this.getEnv === "prod") {
      this.currentEvent = {
        promoName: this.getPromoToProd.promoName,
        eventDateStart: "",
        eventDateEnd: "",
        stats: "",
        imageSrc: this.getPromoToProd.imageSrc,
        htmlText: this.getPromoToProd.htmlText,
        link: this.getPromoToProd.link,
        gameIDs: this.getPromoToProd.gameIDs,
        showImages: this.getPromoToProd.showImages ?? false,
        mobileImageSrc: this.getPromoToProd.mobileImageSrc || "",
      };
      this.eventTab = "newEventTab";
      // Clear persistDate after we fill the form
      this.setPromoToProd({});
    } else {
      this.newEvent();
    }

    // clear persistDate if is Stage
    if (this.getEnv === "stage") {
      this.setPromoToProd({});
    }
  },

  computed: {
    ...mapGetters({
      getCrossPromotions: "crossPromotion/getCrossPromotions",
      getCrossPromotionsLoading: "crossPromotion/getCrossPromotionsLoading",
    }),
    ...mapGetters({
      getGamesList: "games/getGamesList",
    }),
    ...mapGetters({
      getIsOpenSelectImageModal: "selectImage/getIsOpenModal",
    }),
    ...mapGetters({
      getEnv: "selectEnv/getEnv",
    }),
    ...mapGetters({
      getPromoToProd: "generalPersist/getPromoToProd",
    }),

    truncatedHtmlText() {
      if (this.currentEvent.htmlText.length > 80) {
        return this.currentEvent.htmlText.substring(0, 80) + "...";
      }
      return this.currentEvent.htmlText;
    },
  },

  methods: {
    ...mapActions({
      actionGetCrossPromotions: "crossPromotion/actionGetCrossPromotions",
      actionSetCrossPromotion: "crossPromotion/actionSetCrossPromotion",
      actionDeleteCrossPromotion: "crossPromotion/actionDeleteCrossPromotion",
    }),
    ...mapActions({
      setSelectImageOpenModal: "selectImage/setOpenModal",
    }),
    ...mapActions({
      actionGetGamesFeed: "games/actionGetGamesFeed",
    }),
    ...mapActions({
      setPromoToProd: "generalPersist/setPromoToProd",
    }),
    ...mapActions({
      setEnv: "selectEnv/setEnv",
    }),

    async getAllPromos() {
      this.initialDate = new Date().toDateString();
      this.proxyDate = new Date().toDateString();
      await this.actionGetCrossPromotions(this.getEnv)
        .then((response) => {
          if (response) {
            this.crossPromotionsList = _.cloneDeep(response);
          }
          this.promoEventsFirstDate = new Date(
            this.crossPromotionsList[
              this.crossPromotionsList.length - 1
            ].eventDateStart
          ).toDateString();
          this.promoEventsLastDate = new Date(
            this.crossPromotionsList[0].eventDateEnd
          ).toDateString();
        })
        .catch((err) => {
          console.log("err: ", err);
        });
    },

    sendToProd() {
      this.setPromoToProd({
        promoName: this.currentEvent.promoName,
        eventDateStart: "",
        eventDateEnd: "",
        stats: "",
        link: this.currentEvent.link,
        htmlText: this.currentEvent.htmlText,
        imageSrc: this.currentEvent.imageSrc,
        gameIDs: this.currentEvent.gameIDs,
        showImages: this.currentEvent.showImages ?? false,
        mobileImageSrc: this.currentEvent.mobileImageSrc || "",
      });
      this.setEnv("prod");
    },

    newEvent() {
      this.currentEvent = {
        promoName: "",
        eventDateStart: "",
        eventDateEnd: "",
        stats: "",
        gameIDs: [],
        link: "",
        htmlText: "",
        imageSrc: "",
        showImages: true,
        mobileImageSrc: "",
      };

      this.eventTab = "newEventTab";
    },
    async editEvent() {
      this.selectedEventDatePicker = {
        from: this.convertDateIntoAmericanFormat(
          this.currentEvent.eventDateStart
        ),
        to: this.convertDateIntoAmericanFormat(this.currentEvent.eventDateEnd),
      };

      this.eventTab = "editEventTab";
    },
    duplicatePromo(promo) {
      this.currentEvent = {
        promoName: promo.promoName,
        eventDateStart: "",
        eventDateEnd: "",
        stats: "",
        link: promo.link,
        gameIDs: promo.gameIDs,
        htmlText: promo.htmlText,
        imageSrc: promo.imageSrc,
        showImages: promo.showImages ?? false,
        mobileImageSrc: promo.mobileImageSrc || "",
      };
      this.eventTab = "newEventTab";
    },
    handlerDisableCreateEvent() {
      return (
        this.currentEvent.promoName.length < 3 ||
        this.currentEvent.eventDateStart === "" ||
        this.currentEvent.eventDateEnd === "" ||
        this.currentEvent.stats === "closed"
      );
    },

    onChangeEventDate(val) {
      if (!val) {
        this.currentEvent.eventDateStart = "";
        this.currentEvent.eventDateEnd = "";
      } else if (typeof val === "string") {
        this.currentEvent.eventDateStart = val;
        this.currentEvent.eventDateEnd = val;
      } else {
        this.currentEvent.eventDateStart = val.from;
        this.currentEvent.eventDateEnd = val.to;
      }
    },

    onTabChange(val) {
      if (val === "newEventTab") this.newEvent();
    },

    onSearchChange(val) {
      if (val === "") {
        this.searchText = "";
      }
      this.resetPromoEvents();
      this.crossPromotionsList = this.crossPromotionsList.filter((product) => {
        return product.promoName.toLowerCase().indexOf(val.toLowerCase()) != -1;
      });
    },
    resetPromoEvents() {
      this.crossPromotionsList = _.cloneDeep(this.getCrossPromotions);
    },
    // Called when user click in a new promo from the Timeline
    timelineEventChange(promo) {
      this.currentEvent = {
        ...promo,
        showImages: promo.showImages ?? false,
        mobileImageSrc: promo.mobileImageSrc || "",
      };
      // Update the initial date into a american format, to be displayed in the datepicker
      this.initialDate = this.convertDateIntoAmericanFormat(
        promo.eventDateStart
      );
      this.editEvent();
    },
    // save new date in datepicker
    setEventSearchDate() {
      const clonedEvent = _.cloneDeep(
        this.getEventByDate(this.proxyDate, this.crossPromotionsList)
      );
      if (clonedEvent) {
        this.currentEvent = {
          promoName: clonedEvent.promoName,
          eventDateStart: clonedEvent.eventDateStart,
          eventDateEnd: clonedEvent.eventDateEnd,
          stats: clonedEvent.stats,
          eventKey: clonedEvent.eventKey,
          link: clonedEvent.link,
          gameIDs: clonedEvent.gameIDs,
          imageSrc: clonedEvent.imageSrc,
          htmlText: clonedEvent.htmlText,
          showImages: clonedEvent.showImages ?? false,
          mobileImageSrc: clonedEvent.mobileImageSrc || "",
        };
        this.eventTab = "editEventTab";
        this.editEvent();
      } else {
        this.$q.notify({
          type: "warning",
          message: `There's no Promotions at: ${this.convertDateIntoAmericanFormat(
            this.proxyDate
          )}`,
        });
        this.newEvent();
      }
      this.initialDate = this.convertDateIntoAmericanFormat(this.proxyDate);
    },
    // Timeline Date picker functions
    updateProxyDateInTimeline() {
      this.proxyDate = this.convertDateIntoAmericanFormat(this.initialDate);
    },

    availableEventsDates(date) {
      return this.datePickerTimelineOptionsFn(
        date,
        this.promoEventsFirstDate,
        this.promoEventsLastDate
      );
    },

    displayDatesInTimeline(dateStart, dateEnd) {
      return (
        new Date(dateStart).toLocaleDateString("en-us", {
          year: "numeric",
          month: "long",
          day: "numeric",
        }) +
        " - " +
        new Date(dateEnd).toLocaleDateString("en-us", {
          year: "numeric",
          month: "long",
          day: "numeric",
        })
      );
    },

    async createEventConfirm() {
      const newPromoEvent = _.cloneDeep(this.currentEvent);
      this.createEventModal = false;

      await this.actionSetCrossPromotion({
        ...newPromoEvent,
        gameIDs: this.currentEvent.gameIDs,
        isTargetBlank: true,
      })
        .then(async () => {
          await this.getAllPromos();
          this.$q.notify({
            type: "positive",
            message: `The promotion was successfully ${
              newPromoEvent.eventKey ? "Edited" : "Created"
            }`,
          });
          this.newEvent();
        })
        .catch((err) => {
          this.$q.notify({
            type: "negative",
            message: err.response.data.details[0].Message,
          });
        });
      this.onSearchChange("");
    },

    async deleteEventConfirm() {
      this.deleteEventModal = false;
      await this.actionDeleteCrossPromotion(this.currentEvent.eventKey)
        .then(async () => {
          await this.getAllPromos();
          this.$q.notify({
            type: "positive",
            message: `The promotion was successfully Deleted`,
          });
          this.newEvent();
        })
        .catch(() => {
          this.$q.notify({
            type: "negative",
            message: `An error occurred trying to Delete`,
          });
        });
      this.onSearchChange("");
    },

    async httpCheck(val) {
      return val.startsWith("http");
    },

    selectImageURL() {
      this.setSelectImageOpenModal(true);
    },
  },

  watch: {
    currentEvent() {
      this.selectedEventDatePicker = {
        from: this.convertDateIntoAmericanFormat(
          this.currentEvent.eventDateStart
        ),
        to: this.convertDateIntoAmericanFormat(this.currentEvent.eventDateEnd),
      };
      this.updateGamesFilterKey = !this.updateGamesFilterKey;
    },
  },
};
</script>

<style lang="scss" scoped>
@import url("https://fonts.googleapis.com/css2?family=Montserrat:wght@400;700&display=swap");

.new-tab-loading-wrapper {
  min-height: 60vh;
  position: relative;

  div {
    position: absolute;
    left: 50%;
    top: 10%;
  }
}

.icons-wrapper {
  padding: 0 10px;
  margin-left: auto;
  font-size: 24px;
  color: $primary;
  transition: all 0.4s ease-in-out;
  width: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.icon-content {
  svg {
    height: 20px;
  }
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    color: $red;
  }
}

.promo-banner-container {
  position: relative;
  width: 100%;
  display: flex;
  min-height: 260px;
  background-color: $white;
  box-shadow: 0 1px 4px rgb(0 0 0 / 35%);
  flex-direction: column;
  justify-content: center;
}

.relative-class {
  position: relative;
}

.timeline-card {
  position: relative;
  max-height: 60vh;
  height: 60vh;
  overflow: scroll;
  overflow-x: hidden;
}

.timeline-entry {
  cursor: pointer !important;
}

.timeline-card-section {
  position: sticky;
  min-height: 80px;
  top: 0;
  background-color: rgb(241, 241, 241);
  z-index: 2;
  width: 100%;
}

.card-modal {
  width: 600px;
  max-width: 80vw;
}

.row-border {
  margin-left: auto;
  margin-right: auto;
  border: 1px solid gray;
  max-width: 1140px;
  min-height: 280px;
}

.fill {
  overflow: hidden;
}
.fill img {
  width: 100%;
  height: 100px;
  object-fit: cover;
  object-position: center;
}

.promo-content-wrapper {
  display: flex;
  background-color: #ffffff;
  border-radius: 8px;
  box-shadow: 1px 1px 5px 0px rgba(0, 0, 0, 0.2);
  min-height: 100px;
  height: 100px;
  overflow: hidden;
  width: 100%;
}

.mobile-promo {
  width: 311px;
}

.desktop-promo {
  width: 350px;
}

.promo-content {
  font-family: "Montserrat" !important; /* Apply Montserrat font */
  overflow: hidden;
  height: 100px;
  font-size: 16px;
  color: #333333;
  padding: 8px;
}

.promo-content * {
  font-size: 1rem;
}

.no-image-icon {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  svg {
    height: 50px;
  }
}

.promo-title {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 10px;
  font-weight: 600;
}

.align-promo {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
</style>
